<template>
  <ButtonNav
    :icon="appListMap[appId].icon"
    :label="i18n.global.t(`api.AppId.${appId}`)"
    :route-to="{
      name: appListMap[appId].route as any,
    }"
    :disabled="appStore.isNavigating"
  />
</template>

<script setup lang="ts">
import {
  i18n,
} from '@i18n';
import ButtonNav from '@qmulus/ui/components/app-navbar/button-nav.vue';

import {
  useAppStore,
} from '@/store/pinia/app.ts';
import {
  EAppId,
} from '@/types/app-type.ts';
import {
  appListMap,
} from '@/types/app-util.ts';

const appStore = useAppStore();

defineProps<{
  appId: EAppId,
}>();
</script>
